import {
  ElementsState,
  ExtendedElementTypes,
  FirstLevelElement,
  ROOT_ID,
} from "../canvas/elements.ts";
import { defaultScreenDesignSpecification } from "../canvas/screenDesignSpecification/defaultScreenDesignSpecification.ts";
import { SupportedScreens } from "../canvas/supportedScreens.ts";

import { Bounds, BoundsUtils } from "./bounds.ts";
import { Point } from "./point.ts";

export const SCREEN_PADDING = 64;

export const calculateBoundingBox = (
  selectedElements: string[],
  elements: ElementsState,
): Bounds => {
  let bounds = BoundsUtils.makeNull();

  selectedElements.forEach((elementId) => {
    const element = elements[elementId];
    if (!element || element.type === ExtendedElementTypes.Root) return;

    bounds = BoundsUtils.union(
      bounds,
      BoundsUtils.getElementDocumentBounds(element, elements),
    );
  });

  return bounds;
};

export const visualBoundingBox = (elements: ElementsState): Bounds => {
  const rootElement = elements[ROOT_ID];
  if (!rootElement || rootElement.type !== ExtendedElementTypes.Root) {
    return BoundsUtils.makeNull();
  }

  return calculateBoundingBox(rootElement.children, elements);
};

export const rightMostElement = (
  fistLevelElements: FirstLevelElement[],
): FirstLevelElement | null => {
  let rightMostElement: FirstLevelElement | null = null;
  let maxX = -Infinity;
  for (const element of fistLevelElements) {
    const rightX = element.x + element.width;
    if (rightX > maxX) {
      maxX = rightX;
      rightMostElement = element;
    }
  }
  return rightMostElement;
};

const DEFAULT_DIMENSIONS =
  SupportedScreens[defaultScreenDesignSpecification.screenType];

export const loadingIndicatorPosition = (
  rightMostElement: FirstLevelElement | null,
): { position: Point; width: number; height: number } => {
  let maxX: number;
  let width: number;
  let height: number;
  if (rightMostElement) {
    maxX = rightMostElement.x + rightMostElement.width;
    width = rightMostElement.width;
    // height is not calculated on server, so we just use default height for now
    //height = rightMostElement.height;
    height = DEFAULT_DIMENSIONS[1];
  } else {
    maxX = 0;
    width = DEFAULT_DIMENSIONS[0];
    height = DEFAULT_DIMENSIONS[1];
  }

  const centerInDocumentSpace: Point = {
    x: maxX + SCREEN_PADDING + width / 2,
    y: height / 2,
  };

  return { position: centerInDocumentSpace, width, height };
};

export const compareElementsByCoordinates = <
  T extends { x: number; y: number },
>(
  a: T,
  b: T,
): number => {
  return a.x - b.x || a.y - b.y;
};
